export default __webpack_public_path__ + "static/media/handwriting.149cd796.png";